// settings-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'set.msg.saved.settings': 'Innstillinger lagret',
  'set.msg.saved.business': 'Foretak lagret',
  'set.msg.saved.accounting': 'Regnskap lagret',
  'set.msg.saved.startup': 'Oppstartstall lagret',
  'set.msg.saved.openingBalance': 'Inngående balanse lagret',
  'set.msg.saved.bank': 'Bank lagret',
  'set.msg.saved.import': 'Import lagret',
  'set.msg.saved.productImport': 'Import av produkter lagret',
  'set.msg.saved.generic': '{label} lagret',
  'set.msg.settingsNotConnected': 'Innstillinger er ikke koblet til backend.',
  'set.msg.settingsSaveFailed': 'Kunne ikke lagre innstillinger.',
  'set.msg.backendActionNotConnected': 'Backend er ikke koblet til denne handlingen.',
  'set.msg.saveFailed': 'Kunne ikke lagre.',
  'set.msg.businessNotFound': 'Fant ikke foretaket.',
  'set.msg.profileSaved': 'Brukerprofil lagret',
  'set.msg.profileSaveFailed': 'Kunne ikke lagre brukerprofil.',
  'set.msg.invitesNotConnected': 'Invitasjoner er ikke koblet til backend i denne builden.',
  'set.msg.inviteCreatedEmailFailed': 'Invitasjonen er opprettet, men e-posten kunne ikke sendes.',
  'set.msg.inviteSent': 'Invitasjon sendt på e-post',
  'set.msg.inviteSendFailed': 'Kunne ikke sende invitasjon.',
  'set.msg.ownershipNotConnected': 'Eierskifte er ikke koblet til backend i denne builden.',
  'set.msg.ownershipConfirm': 'Send invitasjon om eierskifte? Den nye brukeren blir eier når invitasjonen godtas.',
  'set.msg.ownershipCreatedEmailFailed': 'Eierskifte er opprettet, men e-posten kunne ikke sendes.',
  'set.msg.ownershipInviteSent': 'Eierskifte-invitasjon sendt på e-post',
  'set.msg.ownershipSendFailed': 'Kunne ikke sende eierskifte.',
  'set.msg.removeAccessNotConnected': 'Fjerning av tilgang er ikke koblet til backend.',
  'set.msg.thisUser': 'denne brukeren',
  'set.msg.removeAccessConfirm': 'Fjerne tilgangen til {email}? Brukeren mister tilgang til valgt foretak.',
  'set.msg.accessRemoved': 'Tilgangen er fjernet',
  'set.msg.removeAccessFailed': 'Kunne ikke fjerne tilgang.',
  'set.msg.leaveNotConnected': 'Forlat foretak er ikke koblet til backend.',
  'set.msg.leaveConfirm': 'Fjerne din tilgang til {businessName}? Du må inviteres på nytt for å få tilgang igjen.',
  'set.msg.leftBusiness': 'Du har forlatt foretaket',
  'set.msg.leaveFailed': 'Kunne ikke fjerne din tilgang.',
  'set.msg.inviteAccepted': 'Invitasjonen er akseptert',
  'set.msg.verifyEmailFirst': 'Bekreft e-postadressen din forst. Vi har sendt deg en ny lenke.',
  'set.msg.inviteAcceptFailed': 'Kunne ikke akseptere invitasjonen.',
  'set.msg.preferencesNotConnected': 'Preferanser er ikke koblet til backend.',
  'set.msg.preferencesSaveFailed': 'Kunne ikke lagre preferanser.',
  'set.msg.documentUploadNotConnected': 'Dokumentopplasting er ikke koblet til backend.',
  'set.msg.documentSaved': 'Dokument lagret',
  'set.msg.documentUploadFailed': 'Kunne ikke laste opp dokumentet.',
  'set.msg.accountNumberAndName': 'Legg inn kontonummer og navn.',
  'set.msg.pickStandardAccount': 'Velg tilsvarende standardkonto.',
  'set.msg.accountNumberExists': 'Kontonummeret finnes allerede.',
  'set.msg.accountNameRequired': 'Legg inn kontonavn.',
  'set.msg.accountAlreadyDeactivated': 'Kontoen er allerede deaktivert og beholdes i historikk.',
  'set.msg.usedIn': ' Den er brukt i {labels}.',
  'set.msg.customAccountDeactivateConfirm': '{name} har historikk.{details}\n\nDeaktivere kontoen i stedet? Den skjules for nye bilag og kontovalg, men beholdes i rapporter, SAF-T og gamle bilag.',
  'set.msg.deleteAccountConfirm': 'Slette {name}? Kontoen er ikke brukt i historikk.',
  'set.msg.pickOtherInvoiceAccount': 'Velg en annen fakturakonto før du kan slette eller deaktivere denne.',
  'set.msg.bankAccountFallback': 'Bankkontoen',
  'set.msg.bankAccountDeactivateConfirm': '{name} har historikk.{details}\n\nDeaktivere kontoen i stedet? Den skjules for nye betalinger og bankvalg, men beholdes i gamle bilag og rapporter.',
  'set.msg.partyIoNotLoaded': 'Import/eksport av registerdata er ikke lastet inn.',
  'set.msg.supplierListDownloaded': 'Leverandørliste lastet ned',
  'set.msg.customerListDownloaded': 'Kundeliste lastet ned',
  'set.msg.partyExportFailed': 'Kunne ikke eksportere registeret.',
  'set.msg.productExportNotLoaded': 'Produkteksport er ikke lastet inn.',
  'set.msg.productListDownloaded': 'Produktliste lastet ned',
  'set.msg.productExportFailed': 'Kunne ikke eksportere produktlisten.',
  'set.msg.invoiceExportNotLoaded': 'Detaljert fakturaeksport er ikke lastet inn.',
  'set.msg.invoiceLinesExported': '{count} fakturalinjer eksportert',
  'set.msg.invoiceExportFailed': 'Kunne ikke eksportere fakturaer.',
  'set.msg.completeExportNotConnected': 'Komplett eksport er ikke koblet til backend ennå.',
  'set.msg.exportPackageNoLink': 'Eksportpakken ble bygget, men mangler nedlastingslenke.',
  'set.msg.completeExportReady': 'Komplett eksport klar: {files} originalfiler og {years} regnskapsår.',
  'set.msg.completeExportFailed': 'Kunne ikke bygge komplett eksport.',
  'set.msg.invoiceTemplateNotLoaded': 'Fakturaimport-mal er ikke lastet inn.',
  'set.msg.invoiceTemplateDownloaded': 'Fakturaimport-mal lastet ned',
  'set.msg.invoiceTemplateExportFailed': 'Kunne ikke eksportere fakturaimport-mal.',
  'set.msg.partyImportNotLoaded': 'Import av registerdata er ikke lastet inn.',
  'set.msg.noValidRows': 'Fant ingen gyldige rader i filen.',
  'set.msg.supplierImportNotConnected': 'Import av leverandører er ikke koblet til backend.',
  'set.msg.customerImportNotConnected': 'Import av kunder er ikke koblet til backend.',
  'set.msg.suppliersImported': '{count} leverandører importert',
  'set.msg.customersImported': '{count} kunder importert',
  'set.msg.partyImportFailed': 'Kunne ikke importere registeret.',
  'set.msg.productImportNotLoaded': 'Produktimport er ikke lastet inn.',
  'set.msg.noProductsInFile': 'Fant ingen produkter i filen.',
  'set.msg.productsImported': '{count} produkter importert',
  'set.msg.productImportFailed': 'Kunne ikke importere produkter. Bruk en CSV- eller XLSX-fil med Plumme produktmal.',
  'set.msg.invoiceImportNotLoaded': 'Fakturaimport er ikke lastet inn.',
  'set.msg.invoiceImportNotConnected': 'Fakturaimport er ikke koblet til backend.',
  'set.msg.noValidInvoiceRows': 'Fant ingen gyldige fakturarader i filen.',
  'set.msg.invoiceImportOver500Confirm': 'Filen inneholder over 500 fakturaer. Fortsette importen som utkast?',
  'set.msg.invoicesImportedAsDraft': '{count} fakturaer importert som utkast',
  'set.msg.invoiceImportDuplicateExisting': 'Filen inneholder fakturanummer som allerede finnes.',
  'set.msg.invoiceImportDuplicateFile': 'Filen inneholder samme fakturanummer flere ganger på ulike fakturaer.',
  'set.msg.invoiceImportFailed': 'Kunne ikke importere fakturaer.',
  'set.msg.jsonMissingState': 'Filen mangler app-state.',
  'set.msg.jsonImportFailed': 'Kunne ikke importere JSON.',
  'set.msg.voucherExportNotLoaded': 'Bilagseksport er ikke lastet inn.',
  'set.msg.vouchersExported': '{count} bilag eksportert',
  'set.msg.postingLinesExported': '{count} bokføringslinjer eksportert',
  'set.msg.voucherExportFailed': 'Kunne ikke eksportere bilagsdata.',
  'set.msg.completeImportNotConnected': 'Komplett regnskapsimport er ikke koblet til backend enna.',
  'set.msg.importFilesCount': '{count} importfiler',
  'set.msg.importAnalysisDone': 'Importanalysen er ferdig.',
  'set.msg.importAnalyzed': 'Import analysert: {files} filer, {saft} SAF-T, {excel} Excel og {csv} CSV.',
  'set.msg.importAnalyzeFailed': 'Kunne ikke analysere komplett regnskapseksport.',
  'set.msg.runAnalysisFirst': 'Kjør importanalyse først.',
  'set.msg.analysisMissingFiles': 'Siste analyse mangler lagrede importfiler. Last opp filene på nytt.',
  'set.msg.reanalyzeNotConnected': 'Reanalyse av komplett import er ikke koblet til backend ennå.',
  'set.msg.reanalyzingSameSet': 'Analyserer samme opplastede filsett på nytt.',
  'set.msg.analysisUpdated': 'Importanalysen er oppdatert fra samme filsett.',
  'set.msg.importReanalyzed': 'Import analysert på nytt: {files} filer, {saft} SAF-T, {excel} Excel og {csv} CSV.',
  'set.msg.reanalyzeFailed': 'Kunne ikke reanalysere komplett regnskapseksport.',
  'set.msg.approveNotConnected': 'Godkjenning av komplett import er ikke koblet til backend ennå.',
  'set.msg.baseDataImported': 'Grunnlagsdata er importert.',
  'set.msg.baseDataImportedCheck': 'Grunnlagsdata er importert. Kontroller inngående balanse før rapportering.',
  'set.msg.approveFailed': 'Kunne ikke godkjenne importen.',
  'set.msg.saftExportNotConnected': 'SAF-T-eksport er ikke koblet til backend.',
  'set.msg.saftExported': 'SAF-T XML eksportert med {count} bilag',
  'set.msg.saftExportFailed': 'Kunne ikke eksportere SAF-T XML.',
  'set.msg.saftAnalyzeFailed': 'SAF-T-filen kunne ikke analyseres. Sjekk at dette er en gyldig SAF-T Financial XML-fil.',
  'set.msg.bulkDeleteNotConnected': 'Massesletting er ikke koblet til backend.',
  'set.msg.bulkDeleted': '{count} {label} slettet',
  'set.msg.bulkDeleteFailed': 'Kunne ikke slette {label}.',
  'set.msg.fullResetNotConnected': 'Full nullstilling er ikke koblet til backend.',
  'set.msg.resetCleanupFailed': 'Dataene ble nullstilt, men opprydding av enkelte filer eller arkiver feilet. Prøv igjen eller kontakt support.',
  'set.msg.mailboxFetched': 'Bilagsinnboks hentet fra backend',
  'set.msg.mailboxFetchFailed': 'Kunne ikke hente bilagsinnboks.',
  'set.msg.mailboxRotateConfirm': 'Generere ny bilagsinnboksadresse? Tidligere adresse slutter å virke.',
  'set.msg.mailboxRotated': 'Ny bilagsinnboksadresse generert',
  'set.msg.mailboxRotateFailed': 'Kunne ikke rotere bilagsinnboks.',
  'set.msg.mailboxCreatedByBackend': 'Opprettes av backend når bilagsinnboks aktiveres',
  'set.msg.logoTooLarge': 'Logo kan maks være 1 MB.',
  'set.msg.logoTypeInvalid': 'Velg PNG, JPG eller WebP som firmalogo.',
  'set.msg.logoReadFailed': 'Kunne ikke lese logo.',
  'set.msg.logoSaved': 'Logo lagret i Firebase Storage',
  'set.msg.logoSaveFailed': 'Kunne ikke lagre logo.',
  'set.msg.logoDeleteConfirm': 'Slette firmalogoen?',
  'set.msg.logoDeleted': 'Logo slettet',
  'set.msg.logoDeleteFailed': 'Kunne ikke slette logo.',
  'set.msg.portalOpenFailed': 'Kunne ikke åpne kundeportal.',
  'set.msg.checkoutFailed': 'Kunne ikke starte betaling.',
  'set.msg.businessScheduledForDeletion': 'Foretaket er planlagt slettet.',
  'set.msg.deletionRegistered': 'Sletting er registrert.',
  'set.msg.deletionScheduleFailed': 'Kunne ikke planlegge sletting.',
  'set.msg.clientSwitchNotConnected': 'Klientbytte er ikke koblet til backend.',
  'set.msg.switchedTo': 'Byttet til {name}',
  'set.msg.switchBusinessFailed': 'Kunne ikke bytte foretak.',
  'set.msg.cancelInviteNotConnected': 'Trekk tilbake invitasjon er ikke koblet til backend.',
  'set.msg.cancelInviteConfirm': 'Trekke tilbake invitasjonen til {email}?',
  'set.msg.inviteCancelled': 'Invitasjonen er trukket tilbake',
  'set.msg.inviteCancelFailed': 'Kunne ikke trekke tilbake invitasjonen.',
  'set.msg.inviteResent': 'Invitasjonen er lagt i utsendingskøen',
  'set.msg.inviteResendFailed': 'Kunne ikke sende invitasjonen på nytt.',
  'set.msg.accessUpdatedLive': 'Tilgang oppdateres fortløpende via backend.',
});
